module.exports = "/_next/static/images/9a16a5c6b8d69609f19192a2eb341f4e-hero-lg.jpg.webp";